import React, { Component } from 'react';
import axios from 'axios';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from 'react-router-dom';
import { debounce } from 'lodash';
import moment from 'moment';
// material
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Container, Grid, IconButton } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
// app
import { updateSession, addAuth, openSnackbar, closeSnackbar } from '../../store/action-creators';
// containers
import AdminContainer from '../../containers/Admin';
import Loader from '../../containers/Loader';
// models
import { Auth, Session } from '../../entities/auth';
import { APIUrl } from '../../entities/site';
import { User } from '../../entities/user';
// components
import Loading from '../../components/site/Loading';
import ActionButton from '../../components/buttons/ActionButton';
import TextInput from '../../components/inputs/TextInput';
import UserSearch from '../../components/site/UserSearch';

import AuthService from '../../services/auth';

const useProd = true;

const styles: any = {
  tableWrapper: {
    maxHeight: 600,
    overflow: 'auto',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    paddingTop: 20,
    paddingBottom: 10,
    textAlign: 'left'
  }
}

interface AdminUsersPageProps {
  history: any;
  auth: Auth;
  session: Session;
  updateSession(session: Session): void;
  openSnackbar(message: string): void;
  closeSnackbar(): void;
}

interface AdminPageState {
  loading: boolean;
  users: User[];
  term: string;
}

class AdminUsersPage extends Component<AdminUsersPageProps, AdminPageState> {

  constructor(props: AdminUsersPageProps) {
    super(props);
    this.state = {
      loading: false,
      users: [],
      term: ''
    }
  }

  componentDidMount = async () => {
    this.fetchUsers();
  }

  fetchUsers = async () => {
    this.setState({ loading: true });
    const usersRes = await axios.get(`${AuthService.getApiUrls().user}/users`);
    this.setState({
      loading: false,
      users: usersRes.data.results
    });
  }

  // changeHandler = (term: string) => {
  //   console.log('term', term);
  // }

  // debouncedChangeHandler = useCallback(
  //   debounce(this.changeHandler, 300)
  // , []);

  searchUsers = async (term: string) => {
    this.setState({ loading: true });
    const usersRes = await axios.post(`${AuthService.getApiUrls().user}/users/_search`, {
      "query": {
        "multi_match": {
          "query": term,
          "type": "phrase_prefix",
          "fields": ["name", "email"]
        }
      }
    });
    this.setState({
      loading: false,
      users: usersRes.data.results
    });
  }

  handleShowLoading = () => {
    this.setState({ loading: true });
  }

  handleNewUser = () => {
    this.props.history.push(`/admin/user/create`);
  }

  handleSearch = (term: string) => {
    this.setState({ term });
    if (term.length > 2) {
      this.searchUsers(term);
    }
    if (term.length === 0) {
      this.fetchUsers();
    }
  }

  handleConfirmUser = async (user: User) => {
    try {
      const usersRes = await axios.post(`${AuthService.getApiUrls().user}/user/cognito/fix`, {
        username: user.userId
      });
      this.props.openSnackbar(`User ${user.name} confirmed`);
    } catch (error) {
      this.props.openSnackbar(error);
    }
  }

  handleSelectUser = (user: any) => {
    console.log('user', user);
  }

  handleSearchResults = (users: User[]) => {
    this.setState({
      users,
      loading: false
    });
  }

  render() {

    return (
      <AdminContainer showOption={false} private={false} maxWidth={false}>
        {/* <Loading open={this.state.loading} /> */}
        <Container maxWidth="lg">
          <Grid container>
            <Grid item xs={10}>
              <div style={{ display: 'flex' }}>
                <div style={styles.title}>Users</div>
                <div style={{ width: 400, marginLeft: 20 }}>
                  {/* <TextInput
                    title=""
                    type="string"
                    placeholder="Search users"
                    result={this.state.term}
                    onChange={(event: any) => this.handleSearch(event.target.value)}
                  /> */}
                  <UserSearch 
                    onResults={this.handleSearchResults}
                    onIsSearching={(isSearching: boolean) => this.setState({loading: isSearching})} 
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={2}>
              <ActionButton name="New User" size="sm" onClick={this.handleNewUser} fullWidth />
            </Grid>
          </Grid>
          <Loader open={this.state.loading}>
            <Paper>
              <div style={styles.tableWrapper}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Phone</TableCell>
                      <TableCell>Roles</TableCell>
                      <TableCell>Created</TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.users.map((user, index) => (
                      <TableRow key={`address-${index}`}>
                        <TableCell component="th" scope="row">{user.userId}</TableCell>
                        <TableCell>{user.name}</TableCell>
                        <TableCell>{user.email}</TableCell>
                        <TableCell>{user.phone}</TableCell>
                        <TableCell>{user.role}</TableCell>
                        <TableCell>{moment(user.createdDate).format('MM-DD-YYYY HH:MM')}</TableCell>
                        <TableCell>
                          <IconButton aria-label="sync campaign" onClick={() => this.handleConfirmUser(user)} >
                            <CheckCircleOutlineIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Loader>
        </Container>
      </AdminContainer>
    )
  }


}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.auth,
    session: state.session.session
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ updateSession, addAuth, openSnackbar, closeSnackbar }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<any, any>(AdminUsersPage));



// WEBPACK FOOTER //
// ./src/pages/admin/AdminUsers.tsx